/**
 * Headers de auth pra fetch direto (componentes que não usam api.js central).
 * Replica a lógica do buildHeaders do api.js: JWT > X-User.
 */
const DEV_USER = import.meta.env.VITE_DEV_USER || 'contato@atriocontabilidade.com.br';

export function authHeaders(extra = {}, isFormData = false) {
  const headers = { ...extra };
  const token = typeof localStorage !== 'undefined' && localStorage.getItem('atrio_jwt');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else {
    headers['X-User'] = DEV_USER;
  }
  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}
